import * as z from 'zod'

export const injuredPersonValidator = z.object({
    injuredPersonName: z.string().optional(),
    injuredPersonAge: z.string().optional(),
    injuredPersonGender: z.string().optional(),
    injuredPersonAddressType: z.string().optional(),
    injuredPersonAddressLine1: z.string().optional(),
    injuredPersonAddressLine2: z.string().optional(),
    injuredPersonCountry: z.string().optional(),
    injuredPersonParish: z.string().optional(),
    injuredPersonDistrict: z.string().optional(),
    injuredPersonRelationshipToInsured: z.string().optional(),
    injuredPersonInjuryName: z.string().optional(),
    wasSeatbeltWorn: z.string().optional(),
    isInjuredPersonTreated: z.string().optional(),
    injuredPersonPhoneNumber: z.string().optional(),
})

export const injuredPedestrianValidator = z.object({
    pedestrianName: z.string().optional(),
    pedestrianGender: z.string().optional(),
    pedestrianPhoneNumber: z.string().optional(),
    pedestrianInjuryName: z.string().optional(),
    isPedestrianTreated: z.string().optional(),
    relationshipToInsured: z.string().optional(),
})

export const witnessValidator = z.object({
    witnessFirstName: z.string().optional(),
    witnessLastName: z.string().optional(),
    witnessRelationshipToInsured: z.string().optional(),
    witnessPhoneNumber: z.string().optional(),
    witnessAddressType: z.string().optional(),
    witnessAddressLine1: z.string().optional(),
    witnessAddressLine2: z.string().optional(),
    witnessCountry: z.string().optional(),
    witnessParish: z.string().optional(),
    witnessDistrict: z.string().optional(),
})

export const propertyValidator = z.object({
    propertyOwnerFirstName: z.string().optional(),
    propertyOwnerLastName: z.string().optional(),
    relationshipToInsured: z.string().optional(),
    propertyAddressType: z.string().optional(),
    propertyAddressLine1: z.string().optional(),
    propertyAddressLine2: z.string().optional(),
    propertyCountry: z.string().optional(),
    propertyParish: z.string().optional(),
    propertyDistrict: z.string().optional(),
    propertyOwnerPhoneNumber: z.string().optional(),
    otherPartyDamageDetails: z.string().optional(),
})

export const otherPartyInjuredPersonValidator = z.object({
    otherPartyInjuredPersonName: z.string().optional(),
    otherPartyInjuredPersonGender: z.string().optional(),
    otherPartyRelationshipToInsured: z.string().optional(),
    otherPartyInjuredPersonAddressType: z.string().optional(),
    otherPartyInjuredPersonAddressLine1: z.string().optional(),
    otherPartyInjuredPersonAddressLine2: z.string().optional(),
    otherPartyInjuredPersonCountry: z.string().optional(),
    otherPartyInjuredPersonParish: z.string().optional(),
    otherPartyInjuredPersonDistrict: z.string().optional(),
    otherPartyInjuredPersonRelationshipToInsured: z.string().optional(),
    otherPartyInjuredPersonInjuryName: z.string().optional(),
    otherPartyIsInjuredPersonTreated: z.string().optional(),
    otherPartyPhoneNumber: z.string().optional(),
})

export const otherPartyVehicleValidator = z
    .object({
        otherVehicleOwnerFirstName: z.string().optional(),
        otherVehicleOwnerLastName: z.string().optional(),
        otherVehicleOwnerTRN: z
            .string()
            .regex(
                /^[1-9]\d{8}$/,
                'TRN must be exactly 9 digits and cannot start with 0'
            )
            .optional(),
        otherVehicleOwnerAddressType: z.string().optional(),
        otherVehicleOwnerAddressLine1: z.string().optional(),
        otherVehicleOwnerAddressLine2: z.string().optional(),
        otherVehicleOwnerCountry: z.string().optional(),
        otherVehicleOwnerParish: z.string().optional(),
        otherVehicleOwnerDistrict: z.string().optional(),
        otherVehicleOwnerPhoneNumber: z.string().optional(),

        otherVehicleInsurer: z.string().optional(),
        otherVehicleYear: z.string().optional(),
        otherVehicleMake: z.string().optional(),
        otherVehicleModel: z.string().optional(),
        otherVehicleRegistrationNumber: z.string().optional(),
        otherVehicleChassisNumber: z.string().optional(),
        otherVehicleEngineNumber: z.string().optional(),

        isDriverSameAsOwner: z.string(),
        otherVehicleDriverFirstName: z.string().optional(),
        otherVehicleDriverLastName: z.string().optional(),
        otherVehicleDriverTRN: z
            .string()
            .regex(
                /^[1-9]\d{8}$/,
                'TRN must be exactly 9 digits and cannot start with 0'
            )
            .optional(),
        otherVehicleDriverPhoneNumber: z.string().optional(),

        otherVehicleDriverLicenseType: z.string().optional(),
        otherVehicleDriverLicenseCountry: z.string().optional(),
        otherVehicleDriverLicenseNumber: z.string().optional(),

        otherVehicleDamageDetails: z.string().optional(),
        otherPartyDamageDetails: z.array(z.string()).optional(),

        isDamageToOtherPartyVehicle: z.string().optional(),
    })
    .superRefine(
        ({ otherVehicleMake, otherVehicleModel }, refinementContext) => {
            if (otherVehicleMake && !otherVehicleModel) {
                return refinementContext.addIssue({
                    code: z.ZodIssueCode.custom,
                    message: 'Required',
                    path: ['otherVehicleModel'],
                })
            }
        }
    )
// .superRefine(({ isVehicleDamaged, OwnerDamageDetails }, refinementContext) => {

//     if (isVehicleDamaged === "yes" && !OwnerDamageDetails) {

//       return refinementContext.addIssue({
//         code: z.ZodIssueCode.custom,
//         message: "You have to select at least one item.",
//         path: ["OwnerDamageDetails"],
//       });
//     }

//   });
